// extracted by mini-css-extract-plugin
module.exports = {"main":"ProfileInfo_main__gQb9x","name":"ProfileInfo_name__3d5o7","info":"ProfileInfo_info__1xfVb","aboutMe":"ProfileInfo_aboutMe__1SVad"};